import service  from "@/utils/http";

export function getTree(itemType) {
  return service({
    url: `/catalogue/getTree/${itemType}`,
    method: "get",
  });
}

//注册
export function register(data) {
  return service({
    url: "/Login/register",
    method: "post",
    data:data
  });
}
//密码登录
export function login(data) {
  return service({
    url: "/Login/pwdLogin",
    method: "post",
    data:data
  });
}
//短信验证码登录
export function noteLogin(data){
  return service({
    url: "/Login/smsLogin",
    method: "post",
    data:data
  });
}
//更新Token
export function tokenLogin(data){
  return service({
    url: "/Login/logout",
    method: "post",
    data:data
  });
}
//发送验证码
export function noteDataLogin(data){
  return service({
    url: "/Login/sendSmsCode",
    method: "post",
    data:data
  });
}
//忘记密码
export function forgetLogin(data){
  return service({
    url: "/Login/forget",
    method: "post",
    data:data
  });
}










